import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

import { InvoiceDetailPage } from '@/features/invoices/components/detail/invoice-detail-page'

export const Route = createFileRoute('/_app/invoices/$invoiceId')({
  component: InvoiceDetailRoute,
})

function InvoiceDetailRoute(): JSX.Element {
  const { invoiceId } = Route.useParams()
  return <InvoiceDetailPage invoiceId={invoiceId} />
}
